const editCookiesPoliciesConstantsAr = {
  cookiesPolicyPageTitle: 'سياسة ملفات تعريف الارتباط',
};

export default editCookiesPoliciesConstantsAr;
